/* Ohora · SEPET HEDİYESİ eşitleyicisi (BOGOS'un yerine, Melih 31.10.2026). Kaynak website/sepet-hediyesi/tema/ (kur.py); temada elle düzenleme ezilir.
   Karar Liquid'de (snippets/ohr-hediye-durum.liquid): hangi kademe hediyesi hak edilir, lamba eklenir mi. Bu dosya yalnız UYGULAR:
   1) Sepete yazan her istek (tema, set oluşturucu, uygulamalar; fetch ya da XHR) görülür → `/?sections=ohr-hediye-durum` okunur.
   2) Fazla / işaretsiz / adedi 1'den farklı hediye satırları satır anahtarıyla düzeltilir (sepette ücretli ürün varsa satır satır
      /cart/change.js, yoksa TEK /cart/update.js; gerekçe uygula()'da), çıkacak satırlar sunucu cevabı beklenmeden gizlenir; eksikler /cart/add.js ile `_hediye` + görünür "Sepet hediyesi" özelliğiyle eklenir. Eklenemeyen
      (stok) bu oturumda atlanır, döngü yok. En çok 3 tur.
   3) Değişiklik olduysa temanın sepeti yenilenir (çekmece: theme:cart:refresh, sepet sayfası: getCart), yüzen düğme aynı cevaptan tazelenir.
   4) Eşitleme sürerken "Ödemeye Geç" ve hızlı ödeme düğmeleri bekler; basıldıysa eşitleme ve sayfa yenilemesi bitince basılır.
   5) Son ücretli satırı silen /cart/change isteği hediyelerle birlikte tek /cart/update'e çevrilir (aşağıda "silmeYakala", 02.11.2026).
   ⛔ Tema adet değişimini satır SIRASIYLA gönderir (/cart/change.js line): hediye satırı eklenip çıkınca sıra kayar, bu yüzden sayfa yenilenmeden
   ödeme formu gönderilmez (sepet sayfasında updates[] konumsal). */
(function () {
  if (window.OhrHediye) return;
  var ayarEl = document.getElementById('ohr-hd-ayar');
  if (!ayarEl) return;
  var AYAR;
  try { AYAR = JSON.parse(ayarEl.textContent); } catch (e) { return; }

  var KOK = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var IZ = 'ohr_hd=1';   // kendi isteklerimiz; izleyici bunları saymaz
  var SEPET_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var OZELLIK = 'Sepet hediyesi';
  var DUGME = '[name="checkout"], .additional-checkout-buttons';
  var calisiyor = false, tekrar = false, kirli = false, zaman = 0, gonderim = null, gecis = false, panelAcik = false;
  var atla = {};
  var sonHediye = AYAR.hediyeVar ? 1 : 0;   // son okunan durumdaki hediye satırı sayısı (silmeYakala boşuna /cart.js okumasın)
  try { atla = JSON.parse(sessionStorage.getItem('ohr-hd-atla') || '{}'); } catch (e) {}

  function hic() {}

  function istek(yol, govde) {
    return fetch(KOK + yol + '?' + IZ, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(govde)
    }).then(function (r) { return { ok: r.ok }; }, function () { return { ok: false }; });
  }

  function durumOku() {
    return fetch(KOK + '?sections=ohr-hediye-durum&' + IZ + '&t=' + Date.now(), {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store'
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j['ohr-hediye-durum']) return null;
      var d = new DOMParser().parseFromString(j['ohr-hediye-durum'], 'text/html');
      var s = d.querySelector('[data-ohr-hd-json]');
      if (!s) return null;
      var o = JSON.parse(s.textContent);
      o.ikon = d.querySelector('[data-ohr-hd-ikon-yeni]');
      return o;
    });
  }

  /* Hedef: istenen hediyelerin her biri 1 adet, işaretli tek satır. Gerisi çıkar. */
  function plan(d) {
    var hedef = {}, tut = {}, up = {}, ekle = [];
    d.istenen.forEach(function (h) { if (!atla[h.v]) hedef[h.v] = h; });
    d.satirlar.forEach(function (l) {
      if (hedef[l.v] && l.i && !tut[l.v]) {
        tut[l.v] = 1;
        if (l.q !== 1) up[l.key] = 1;
      } else {
        up[l.key] = 0;
      }
    });
    Object.keys(hedef).forEach(function (v) {
      if (tut[v]) return;
      var p = { _hediye: hedef[v].no };
      p[OZELLIK] = hedef[v].not;
      ekle.push({ id: +v, quantity: 1, properties: p });
    });
    return { up: up, ekle: ekle };
  }

  function gizle(up) {
    Object.keys(up).forEach(function (k) {
      if (up[k] !== 0) return;
      document.querySelectorAll('[data-ohr-hd-satir]').forEach(function (r) {
        if (r.getAttribute('data-item') === k) r.style.display = 'none';
      });
    });
  }

  function uygula(p, ucretli) {
    var q = Promise.resolve(), anahtarlar = Object.keys(p.up);
    function satirSatir() {
      var s = Promise.resolve();
      anahtarlar.forEach(function (k) { s = s.then(function () { return istek('cart/change.js', { id: k, quantity: p.up[k] }); }); });
      return s;
    }
    if (anahtarlar.length) {
      q = q.then(function () {
        /* Sepette ücretli ürün varken düzeltme /cart/change ile (02.11.2026): BiteSpeed sepeti yalnız add/change sonrası okur; eşik altına
           inen sepetteki eski hediyenin çıktığını ancak böyle görür, yoksa sepet terk linki "eşik altı + hediye" verir. Ücretli ürün yoksa
           TEK /cart/update: "yalnız hediye" ara durumu BiteSpeed'e hiç görünmesin (bkz. silmeYakala). */
        if (ucretli) return satirSatir();
        return istek('cart/update.js', { updates: p.up }).then(function (r) { if (!r.ok) return satirSatir(); });
      });
    }
    if (p.ekle.length) {
      q = q.then(function () {
        return istek('cart/add.js', { items: p.ekle }).then(function (r) {
          if (r.ok) return;
          /* toplu ekleme düştü (çoğunlukla stok): tek tek dene, eklenemeyeni bu oturumda atla */
          var s = Promise.resolve();
          p.ekle.forEach(function (it) {
            s = s.then(function () {
              return istek('cart/add.js', { items: [it] }).then(function (r2) {
                if (r2.ok) return;
                atla[it.id] = 1;
                console.warn('[Ohora hediye] eklenemedi, bu oturumda atlanıyor:', it.id);
              });
            });
          });
          return s.then(function () { try { sessionStorage.setItem('ohr-hd-atla', JSON.stringify(atla)); } catch (e) {} });
        });
      });
    }
    return q;
  }

  function sayfaHediyeSayisi() {
    var kap = document.querySelector('cart-element[data-cart-page] [data-items-holder]') ||
              document.querySelector('cart-element[data-cart-drawer] [data-items-holder]');
    return kap ? kap.querySelectorAll('[data-ohr-hd-satir]').length : null;
  }

  function sayfaTutari() {
    var el = document.querySelector('[data-items-holder] [data-ohr-hd-sepet]');
    return el ? +el.getAttribute('data-tutar') : null;
  }

  function temaYenile() {
    var sayfa = document.querySelector('cart-element[data-cart-page]');
    if (sayfa && typeof sayfa.getCart === 'function') sayfa.getCart();
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  /* Sayfadaki hediye satırları sepetle tutana kadar bekle (en çok 3 sn): sepet sayfasında form ancak o zaman gönderilir */
  function sayfaBekle(beklenen) {
    return new Promise(function (bitti) {
      var bas = Date.now();
      (function bak() {
        var n = sayfaHediyeSayisi();
        var yukleniyor = document.querySelector('cart-element.is-loading, [data-items-wrapper].is-loading');
        if ((n === null || n === beklenen) && !yukleniyor) return bitti();
        if (Date.now() - bas > 3000) return bitti();
        setTimeout(bak, 100);
      })();
    });
  }

  function kilit(kapali) {
    document.querySelectorAll(DUGME).forEach(function (b) {
      b.classList.toggle('ohr-hd-bekle', kapali);
      if (kapali) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }

  function ikonUygula(yeni) {
    var kok = document.querySelector('[data-ohr-hd-ikon]');
    if (!kok || !yeni) return;
    kok.innerHTML = yeni.innerHTML;
    var panel = kok.querySelector('[data-ohr-hd-panel]'), dugme = kok.querySelector('[data-ohr-hd-dugme]');
    if (panel && dugme && panelAcik) { panel.hidden = false; dugme.setAttribute('aria-expanded', 'true'); }
  }

  function esitle() {
    if (calisiyor) { tekrar = true; return; }
    calisiyor = true;
    kirli = false;
    kilit(true);
    var degisti = false, son = null;
    function tur(n) {
      return durumOku().then(function (d) {
        son = d;
        if (!d) return;
        sonHediye = d.satirlar.length;
        var p = plan(d);
        if (!Object.keys(p.up).length && !p.ekle.length) return;
        if (n >= 3) { console.warn('[Ohora hediye] 3 turda eşitlenemedi', p); return; }
        degisti = true;
        gizle(p.up);
        return uygula(p, d.tutar > 0).then(function () { return tur(n + 1); });
      });
    }
    tur(0).catch(hic).then(function () {
      if (son) ikonUygula(son.ikon);
      var bayat = son && sayfaHediyeSayisi() !== null && (sayfaHediyeSayisi() !== son.satirlar.length || (sayfaTutari() !== null && sayfaTutari() !== son.tutar));
      if (degisti || bayat) temaYenile();
      return son && (degisti || bayat) ? sayfaBekle(son.satirlar.length) : null;
    }).then(function () {
      calisiyor = false;
      if (tekrar) { tekrar = false; esitle(); return; }
      kilit(false);
      if (gonderim) {
        var g = gonderim;
        gonderim = null;
        var b = document.contains(g) ? g : document.querySelector('[name="checkout"]');
        if (b) { gecis = true; b.click(); gecis = false; } else { location.href = KOK + 'checkout'; }
      }
    });
  }

  function planla() {
    kirli = true;
    kilit(true);
    clearTimeout(zaman);
    zaman = setTimeout(esitle, 60);
  }

  /* Son ücretli satır silinirken hediyeler AYNI istekte çıkar (02.11.2026, #54752 · #54753): sepet bir an bile "yalnız hediye" kalmasın.
     BiteSpeed'in betiği her /cart/change ve /cart/add'den sonra /cart.js'i okuyup sepet terk mesajı için saklıyor; /cart/update'i ve boş
     sepeti görmüyor. Ücretli satır silinip hediyeyi eşitleyici çıkarana kadarki ara durum ("yalnız hediye") onda kalıyor, mesajdaki link
     0 TL'lik hediyeyi doğrudan ödemeye götürüyordu. Tema silmeyi /cart/change.js {line|id, quantity: 0} ile gönderir; o istek bu sepeti
     yalnız hediyeye düşürecekse tek /cart/update.js'e çevrilir (satır + bütün hediyeler 0). Hediye satırı kuralı Liquid'dekiyle aynı. */
  var DEGIS_RE = /\/cart\/change(\.js|\.json)?(\?|$)/;
  function hediyeSatiri(it) {
    return !!(it.properties && it.properties._hediye) || String(it.handle || '').indexOf('-sca_clone_freegift') > -1;
  }
  function govdeOku(b) {
    try {
      if (typeof b === 'string') return b.charAt(0) === '{' ? JSON.parse(b) : Object.fromEntries(new URLSearchParams(b));
      if (b instanceof URLSearchParams || b instanceof FormData) return Object.fromEntries(b);
    } catch (e) {}
    return null;
  }
  function silmeYakala(ctx, args) {
    var g = govdeOku(args[1] && args[1].body);
    if (!g || +g.quantity !== 0 || !(g.line || g.id) || (!sonHediye && !document.querySelector('[data-ohr-hd-satir]'))) return null;
    return asilFetch(KOK + 'cart.js?' + IZ, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      var hedef = g.line ? c.items[+g.line - 1] : c.items.filter(function (it) { return it.key === String(g.id) || it.variant_id === +g.id; });
      if (Array.isArray(hedef)) hedef = hedef.length === 1 ? hedef[0] : null;
      var hediyeler = c.items.filter(hediyeSatiri);
      var kalan = c.items.filter(function (it) { return it !== hedef && !hediyeSatiri(it); });
      if (!hedef || hediyeSatiri(hedef) || kalan.length || !hediyeler.length) return asilFetch.apply(ctx, args);
      var up = {};
      up[hedef.key] = 0;
      hediyeler.forEach(function (it) { up[it.key] = 0; });
      gizle(up);
      var govde = { updates: up };
      if (g.sections) { govde.sections = g.sections; if (g.sections_url) govde.sections_url = g.sections_url; }
      return asilFetch(KOK + 'cart/update.js?' + IZ, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(govde)
      });
    }).catch(function () { return asilFetch.apply(ctx, args); });
  }

  /* Sepeti kim değiştirirse değiştirsin: fetch + XHR sarmalama (kendi isteklerimiz hariç) */
  var asilFetch = window.fetch;
  window.fetch = function (girdi) {
    var url = typeof girdi === 'string' ? girdi : (girdi && girdi.url) || '';
    var p = (DEGIS_RE.test(url) && url.indexOf(IZ) < 0 && silmeYakala(this, arguments)) || asilFetch.apply(this, arguments);
    if (SEPET_RE.test(url) && url.indexOf(IZ) < 0) p.then(planla, hic);
    return p;
  };
  var asilOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (yontem, url) {
    var u = String(url || '');
    if (SEPET_RE.test(u) && u.indexOf(IZ) < 0) this.addEventListener('loadend', planla);
    return asilOpen.apply(this, arguments);
  };
  /* Sarmalamadan önce fetch'i kopyalamış betikler için yedek */
  try {
    new PerformanceObserver(function (liste) {
      liste.getEntries().forEach(function (e) {
        if (SEPET_RE.test(e.name) && e.name.indexOf(IZ) < 0) planla();
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}

  /* Ödemeye Geç / hızlı ödeme: eşitleme sürüyorsa ya da bekliyorsa tıklamayı tut, bitince yeniden bas */
  window.addEventListener('click', function (e) {
    if (gecis || (!calisiyor && !kirli)) return;
    var b = e.target.closest && e.target.closest(DUGME);
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    gonderim = b.matches('[name="checkout"]') ? b : null;
    if (!calisiyor) { clearTimeout(zaman); esitle(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var b = e.submitter;
    if (gecis || !b || b.name !== 'checkout' || (!calisiyor && !kirli)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    gonderim = b;
    if (!calisiyor) { clearTimeout(zaman); esitle(); }
  }, true);

  /* Yüzen düğme + panel (olay devri: içerik her eşitlemede yenilenir) */
  function panelAc(acik, odakla) {
    var kok = document.querySelector('[data-ohr-hd-ikon]');
    if (!kok) return;
    var panel = kok.querySelector('[data-ohr-hd-panel]'), dugme = kok.querySelector('[data-ohr-hd-dugme]');
    if (!panel || !dugme) return;
    panelAcik = acik;
    panel.hidden = !acik;
    dugme.setAttribute('aria-expanded', acik ? 'true' : 'false');
    if (acik && odakla) { var k = panel.querySelector('[data-ohr-hd-kapat]'); if (k) k.focus({ preventScroll: true }); }
    if (!acik && odakla) dugme.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var kok = document.querySelector('[data-ohr-hd-ikon]');
    if (!kok) return;
    if (e.target.closest('[data-ohr-hd-dugme]')) { panelAc(!panelAcik, true); return; }
    if (e.target.closest('[data-ohr-hd-kapat]')) { panelAc(false, true); return; }
    if (panelAcik && !kok.contains(e.target)) panelAc(false, false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panelAcik) panelAc(false, true); });

  /* Yüzen düğme WhatsApp düğmesiyle aynı yükseklikte (o yüklenince ve pencere boyu değişince ölçülür; yoksa CSS'teki değer).
     01.11.2026'dan beri WhatsApp düğmesi temada (snippets/ohr-whatsapp.liquid, [data-ohr-wa]); CKWhatsApp'ınki yedek. */
  function hizala() {
    var kok = document.querySelector('[data-ohr-hd-ikon]'), wa = document.querySelector('[data-ohr-wa]') || document.getElementById('carthike-chat-button-container');
    if (!kok || !wa) return;
    var r = wa.getBoundingClientRect();
    if (r.height > 0 && r.bottom > 0) kok.style.bottom = Math.max(12, Math.round(window.innerHeight - r.bottom)) + 'px';
  }
  [600, 1500, 3500].forEach(function (ms) { setTimeout(hizala, ms); });
  window.addEventListener('resize', function () { clearTimeout(hizala.z); hizala.z = setTimeout(hizala, 200); });

  window.addEventListener('pageshow', function (e) { if (e.persisted) planla(); });   // geri tuşu (bfcache)
  document.addEventListener('visibilitychange', function () {   // başka sekmede sepet değişmiş olabilir
    if (document.visibilityState === 'visible' && (AYAR.acik || AYAR.hediyeVar)) planla();
  });

  window.OhrHediye = { esitle: planla, ayar: AYAR };
  if (AYAR.dolu > 0 || AYAR.hediyeVar) planla();
})();
